export const CUSTOMTEXT_HEADER = 'Landingsside_Overskrift'
export const CUSTOMTEXT_FORKJOP = 'Landingsside_Forkjop'
export const CUSTOMTEXT_INGRESS = 'Landingsside_Ingress'
export const CUSTOMTEXT_MINSIDE = 'Landingsside_MinSide'
export const CUSTOMTEXT_PORTAL = 'Landingsside_Styreportalen'
